var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sheet-wrapper",class:{
    'sheet-wrapper--popup': _vm.isPopup,
    'sheet-wrapper--fit': _vm.fitContent,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }